/**
 * The mode a URL asks for, if it asks for one.
 *
 * `?mode=raid` opens straight into that mode rather than into the menu, which is a link anyone can
 * paste and the only way an automated tool can reach a mode it did not write. Without it a tool has
 * to press whichever card the menu happens to render first, which makes registry order a
 * contract nobody declared: `tools/bin/screenshot.mjs` did exactly that and could only ever
 * photograph `MODES[0]`.
 *
 * Resolved through the registry, so an id this build has never heard of is not a mode. That is the
 * same answer as no parameter at all on purpose: a stale link is a player who lands on the menu,
 * not a player who lands on an error about a query string.
 */

import { findMode } from '@/modes/modeRegistry';
import type { GameMode } from '@/modes/modeContract';

/** Null when nothing was asked for, and when what was asked for is not a mode this build has. */
export function modeFromUrl(search: string): GameMode | null {
  const id = new URLSearchParams(search).get('mode');
  return id === null ? null : findMode(id);
}
